<template>
    <base-form-control
        v-bind="formControlAttributes"
        @clear-clicked="clear"
    >
        <slot name="prepend"></slot>

        <label class="form-file text-truncate">
            <span v-if="text === ''">Browse</span>
            <span v-else>{{ text }}</span>

            <input
                v-on="fileListeners"
                @change="updateValue"
                :disabled="disabled"
                type="file"
            />
        </label>

        <slot name="append"></slot>
    </base-form-control>
</template>

<script>
import BaseFormControl from 'lego-framework/src/forms/BaseFormControl';
import BaseInput from 'lego-framework/src/forms/BaseInput';

export default {
    name : 'form-file-input',

    components : {
        BaseFormControl
    },

    extends : BaseInput,

    data () {
        return {
            text : ''
        };
    },

    computed : {
        fileListeners () {
            const listeners = { ...this.listeners };

            // Remove BaseInput's input listener.
            delete listeners.input;

            return listeners;
        }
    },

    methods : {
        updateValue (evt) {
            const files = Array.from(evt.target.files);

            if (!files.length) {
                return;
            }

            this.files = files;
            this.text = files[0].name;

            this.$emit('input', files);
        },
        clear () {
            this.text = '';
            this.files = [];
            this.$emit('input', []);
        }
    }
};
</script>
